import { render, staticRenderFns } from "./ShopItem.vue?vue&type=template&id=7d6a8184&scoped=true"
import script from "./ShopItem.vue?vue&type=script&lang=js"
export * from "./ShopItem.vue?vue&type=script&lang=js"
import style0 from "./ShopItem.vue?vue&type=style&index=0&id=7d6a8184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6a8184",
  null
  
)

export default component.exports